import React from 'react';
import SecuredFooter from './SecuredFooter';

/**
 * The single centered card every hosted screen renders in (464px white
 * card on #f4f6f9). Collapses to a full-width single column on mobile.
 */
const CardShell = ({ children }) => (
	<div className="flex min-h-screen justify-center bg-pay-bg px-[16px] py-[48px]">
		<div className="flex h-fit w-full max-w-[464px] flex-col gap-[18px] rounded-[22px] bg-white p-[32px] shadow-card">
			{children}
			<SecuredFooter />
		</div>
	</div>
);

export default CardShell;
